import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useClickOutside from '@hooks/useClickOutside';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { getColors } from '@store/design/action';
import { getAllColors } from '@store/reducers';

const SearchWithAddColor = ({ onEditClick, selectedColorList, onAddNewColor }) => {
	const colorRef = useRef({});
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(openLoader());
		dispatch(getColors()).finally(() => {
			dispatch(closeLoader());
		});
	}, []);

	let colors = useSelector(getAllColors);
	colors = colors.map((item) => {
		return {
			id: item.id,
			pantoneColorId: item.id,
			name: item.name,
			code: item.code,
			hexCode: item.hexCode
		};
	});

	const onSearchColor = (e) => dispatch(getColors(e.target.value));
	const getFilteredColors = () => {
		let colorLists = [...selectedColorList];
		return colors.filter((o1) => !colorLists.some((o2) => o1.pantoneColorId === o2?.pantoneColorId));
	};

	const onOutSideClick = () => {
		onEditClick();
	};
	useClickOutside(colorRef, onOutSideClick);
	return (
		<div className="color-list-select-popup" ref={colorRef}>
			<div className="m-0 search-filter">
				<div className="with-icon right-icon">
					<input type="text" autoComplete="off" placeholder="Search" onChange={onSearchColor} />
					<span className="right-icon">
						<img
							src={`${process.env.PUBLIC_URL}/icons/search.png`}
							alt={`${process.env.PUBLIC_URL}/icons/search.png`}
						/>
					</span>
				</div>
			</div>

			<div className="color-list-box scroll-y-label">
				{getFilteredColors()?.map((item) => (
					<div
						className="single-color-item d-flex"
						key={item.id}
						onClick={() => {
							onAddNewColor(item);
							onEditClick();
						}}
					>
						<div className="one-half color-code">
							<span className="color-icon" style={{ background: item.hexCode }} />
							<span className="regular-14">{item.code}</span>
						</div>
						<div className="one-half color-name">
							<p className="regular-14">{item.name}</p>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default SearchWithAddColor;
